
import Button from '@/components/NewUiElements/Buttons/Button'
export default {
    name: 'CreateFolderModal',
    components: { Button },
    props: {
        value: {
            type: null,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            name: ''
        }
    },
    watch: {
        name () {
            this.$emit('input', this.name)
        }
    },
    mounted () {
        this.$refs.name.focus()
    },
    methods: {
        create () {
            if (this.name.length === 0 || this.disabled) { return }
            this.$emit('create-folder', this.name)
        }
    }
}
